import { render, staticRenderFns } from "./HelpDeskForm.html?vue&type=template&id=05cb49fe&external"
import script from "./HelpDeskForm.vue?vue&type=script&lang=js"
export * from "./HelpDeskForm.vue?vue&type=script&lang=js"
import style0 from "./HelpDeskForm.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports